import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { AdminService } from '../../services/admin.service';
import { MasterDTO } from '../../model/admin.entity';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { StandardDTO } from '../../model/standard.entity';
import { Router } from '@angular/router';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Component({
  selector: 'tandc-standard',
  templateUrl: './standard.component.html',

})
export class StandardComponent implements OnInit {

  standardList: StandardDTO[] = [];
  model: StandardDTO = new StandardDTO();
  showModal: boolean = false;
  modalTitle: string = "";
  @ViewChild('dt')
  dt!: Table;

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
    private router: Router,
  private masterDataRepository: MasterDataRepository) { }

  ngOnInit(): void {
    this.getAll();
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getAll() {
    this.service.getStandard().subscribe((x) => {
      this.standardList = x.value;
    });
  }

  addModal() {
    this.router.navigate(['admin/save-standard']);
    // this.model = new StandardDTO();
    // this.showModal = !this.showModal;
    // this.modalTitle =
    //   this.translate.instant('commonbtn.add') +
    //   ' ' +
    //   this.translate.instant('Master.standard');
  }

  // save(data: StandardDTO) {
  //   if (data.id > 0) {
  //     this.service.updateStandard(data).subscribe((res) => {
  //       if (res) {
  //         this.showModal = !this.showModal;
  //         this.commonService.successMessage(
  //           this.translate.instant('Alerts.UpdatedSuccessfully')
  //         );
  //         this.getAll();
  //       }
  //     });
  //   } else {
  //     this.service.saveStandard(data).subscribe((res) => {
  //       if (res) {
  //         this.showModal = !this.showModal;
  //         this.commonService.successMessage(
  //           this.translate.instant('Alerts.SavedSuccessfully')
  //         );
  //         this.getAll();
  //       }
  //     });
  //   }
  // }

  delete(data: StandardDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      accept: () => {
        if (data) {
          this.service.deleteStandard(data.id).subscribe((res) => {
            if (res) {
              this.commonService.successMessage(
                this.translate.instant('Alerts.DeleteSuccessfully')
              );
              this.getAll();
            }
          });
        }
      },
    });
  }

  onToggleStatus(item: MasterDTO) {
  const updatedItem = {
    ...item,
    PerformanceCriteria: item.PerformanceCriteria || []  // Ensure required field
  };
  this.service.updateStandard(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }


  edit(data: StandardDTO) {
    this.router.navigate(['admin/save-standard', data.id]);
    this.model = data;
    this.showModal = !this.showModal;
  }


  copy(data: StandardDTO) {
  
    this.service.getStandardById(data.id).subscribe(fullData => {
      const newData = { ...fullData.value, id: 0 }; // mark as new
      this.router.navigate(['admin/save-standard'], { state: { copiedData: newData } });
    });
  }

  downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export() {
    this.masterDataRepository.export('standard').subscribe(blob => {
      this.downloadFile(blob, `standard-${new Date().toISOString().slice(0,10)}.xlsx`);
    });
  }


}
